module.exports = __webpack_public_path__ + "img/witch_doctor.bc8bb980.png";